import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProcessoQuestoes } from '../../../models/processo-questoes.model';
import { ProcessoQuestoesService } from '../../../services/processo-questoes.service';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';

@Component({
  selector: 'app-processo-questoes-list',
  templateUrl: './processo-questoes-list.component.html',
  styleUrls: ['./processo-questoes-list.component.scss']
})
export class ProcessoQuestoesListComponent extends BaseListComponent<ProcessoQuestoes> implements OnInit {

  idProcesso: number;
  list: ProcessoQuestoes[];
  permission: any;
  question: { id?: number, question_id?: number } = {};
  questionList: any;
  modalRef?: BsModalRef;

  @ViewChild('modal') modal: TemplateRef<any>;

  constructor(
    public activatedRoute: ActivatedRoute,
    public processoQuestoesService: ProcessoQuestoesService,
    private navigation: NavigationService,
    private modalService: BsModalService,
  ) {
    super();
  }

  ngOnInit() {
    this.idProcesso = this.activatedRoute.parent.snapshot.params.id;
    this.initList();
  }

  initList() {
    this.loading();
    this.addSub(
      this.processoQuestoesService.getListAll(this.idProcesso).subscribe({
        next: (res) => {
          this.list = res?.['list'];
          this.permission = res?.['permission'];
          this.loaded();
        },
        error: (erro) => {
          this.msgError(erro?.error?.message);
          this.loaded();
        },
      })
    );
  }

  closeModal() {
    this.modalRef?.hide();
  }

  openModal(id: number) {
    this.loading();
    this.question = {};
    this.question.id = id;
    this.addSub(
      this.processoQuestoesService.listQuestion(this.question.id).subscribe({
        next: (res) => {
          this.questionList = res;
          this.loaded();
          this.modalRef = this.modalService.show(this.modal);
        },
        error: (erro) => {
          this.msgError(erro?.error?.message);
          this.loaded();
        },
      })
    );
  }

  salvar() {
    this.closeModal();
    if (this.question.id && this.question.question_id) {
      this.loading();
      this.addSub(
        this.processoQuestoesService.create(this.question).subscribe({
          next: (res) => {
            this.msgSuccess('Questão Vinculada com sucesso!');
            this.initList();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    }
  }

  confirmExcluir(id: number) {
    this.alertConfirmation(id, 'Tem certeza que deseja desvincular essa Questão?').subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: number): void {
    this.loading();
    this.processoQuestoesService.delete(id).subscribe({
      next: (res) => {
        this.initList();
        this.msgSuccess('Desvinculado com sucesso!');
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }

  salvarOrdem(indexGroup: number) {
    this.loading();
    let obj = {
      pp_process_question_order: this.list[indexGroup]?.group
    }
    this.processoQuestoesService.updateOrdem(obj).subscribe({
      next: (res) => {
        this.msgSuccess('Ordem salva com sucesso!');
        this.list[indexGroup].active_ord = false;
        this.loaded();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }

  drop(event: CdkDragDrop<string[]>, indexGroup: number) {
    moveItemInArray(this.list[indexGroup]?.group, event.previousIndex, event.currentIndex);

    this.list[indexGroup]?.group.forEach((item, index) => {
      item.nro_ord = index + 1;
    })
  }
  
  voltar() {
    this.navigation.back(['/pre-projeto', 'processos']);
  }
}
